import { Search, X } from "lucide-react";
import { cx } from "../../utils";

/**
 * The search box and filter dropdowns along the top of a list card.
 *
 *   <ListFilters
 *     search={text} onSearch={setText} placeholder="Search…"
 *     filters={[{ label: "App", value, onChange, options: [["", "All apps"], ["id", "Name"]] }]}
 *     onClear={…}   // shown while any filter or search is set
 *   />
 *
 * A dropdown that's set is tinted, so a filtered list never looks complete.
 */
const ListFilters = ({ search, onSearch, placeholder = "Search", filters = [], onClear, className }) => {
  const active = Boolean(search) || filters.some((f) => f.value);

  return (
    <div className={cx("flex flex-wrap items-center gap-2 border-b border-ink-150 px-4 py-3", className)}>
      <div className="relative min-w-[12rem] flex-1">
        <Search size={14} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" aria-hidden />
        <input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="h-9 w-full rounded-lg border border-ink-200 bg-white pl-9 pr-3 text-[13px] text-ink-900 shadow-sm placeholder:text-ink-400 hover:border-ink-300 focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
        />
      </div>

      {filters.map((f) => (
        <select
          key={f.label}
          value={f.value}
          onChange={(e) => f.onChange(e.target.value)}
          aria-label={f.label}
          className={cx(
            "h-9 cursor-pointer rounded-lg border px-2.5 pr-7 text-[13px] shadow-sm focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-500/20",
            f.value ? "border-brand-300 bg-brand-50/60 text-brand-800" : "border-ink-200 bg-white text-ink-700 hover:border-ink-300",
            f.className || "w-40",
          )}
        >
          {f.options.map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      ))}

      {onClear && active && (
        <button
          type="button"
          onClick={onClear}
          className="inline-flex h-9 items-center gap-1 rounded-lg px-2.5 text-[12.5px] font-medium text-ink-500 hover:bg-ink-100 hover:text-ink-800"
        >
          <X size={13} /> Clear
        </button>
      )}
    </div>
  );
};

export default ListFilters;
